
import { IMediaMonitoringData } from "../types/kato.types";
import { api } from "./api";

const baseUrl = "/public";

export const getGeneralInfo = (kato: number, year = 2024) => {
    return api.get(`${baseUrl}/general`, { params: { kato, year } }).then(res => res.data.data);
}

export const getImageById = (imageId: number) => {
    return `/api/public/image/load?imageId=${imageId}`;
}

export const getMMData = (kato: any): Promise<IMediaMonitoringData[]> => {
    return api.get(`/public/media-monitoring`, { params: { kato } }).then(res => res.data.list)
};

export const getStatistics = (): Promise<any> => {
    return api.get(`${baseUrl}/kato/statistics`).then(res => res.data.data);
}
